<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <app-breadcrumb></app-breadcrumb>
  <div class="d-flex justify-content-between mt-3">
    <div class="d-flex align-items-center px-3"></div>
    <div class="d-flex gap-3">
      <div id="header-container">
        <div class="">
          <div class="search-container">
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
              [(ngModel)]="searchValue" />
          </div>
        </div>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="addTrainingFunc()">
        <img src="../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add New</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="assignTraining()"
        *ngIf="message.isTrainingGroupAdministrator">
        <i class="fa fa-tasks" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Assign Training</span>
      </div>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <div class="tab">
        <mat-tab-group selectedIndex="0" mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4"
          animationDuration="0ms" (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
          <mat-tab *ngFor="let tab of tabsList">
            <ng-template mat-tab-label>
              <span>
                <!-- <i
                          class="fa-solid fa-file-pen"
                          style="font-size: 26px"
                          aria-hidden="true"
                        ></i> -->
                <span *ngIf="tab == 'In Progress'"><i class='fa-solid fa-bars-progress' style="font-size: 18px;"
                    aria-hidden="true"></i></span>
                <span *ngIf="tab == 'Published'"><i class='fas fa-newspaper' style="font-size: 18px;"
                    aria-hidden="true"></i></span>
                <span *ngIf="tab == 'Inactivated'"><i class='fa fa-ban' style="font-size: 18px;"
                    aria-hidden="true"></i></span>
                <span *ngIf="tab == 'Obsoleted'"><i class='fa fa-times' style="font-size: 18px;"
                    aria-hidden="true"></i></span>
                <span *ngIf="tab == 'Expired'"><i class='fa fa-exclamation-triangle' style="font-size: 18px;"
                    aria-hidden="true"></i></span>

              </span>
              &nbsp;<span>{{tab}}</span>
            </ng-template>
            <div class="row">
              <div class="col-md-12" *ngFor="let category of dropDownForCategories"
                style="margin-top: 1%;margin-left: 5px;" id="{{category.trainingCategoryName}}">
                <div class="menu-container">
                  <div class="row menu-row-container">
                    <div class="col-sm-8 gridName-container">
                      <span class="gridName">{{category.trainingCategoryName}}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3"
                    *ngFor="let training of getTraining(category.trainingCategoryCode) | searchFilter : searchValue;"
                    (click)="updateTrainingFunc(training)">
                    <!-- <div class="thumbnail">
                                        <div class="caption">
                                            <div class="container">
                                                <img *ngIf="training.trainingImage == null" style="width:100%;" src="../../assets/img/missing.jpg" />
                                                <img *ngIf="training.trainingImage != null" style="width:100%;" src="data:image/jpg;base64,{{training.trainingImage}}" />
                                                <div *ngIf="training.totalDuration" class="text-block-right">
                                                    <p class="duration">{{training.totalDuration}}</p>
                                                </div>
                                                <div class="text-block-left">
                                                    <p class="type">{{training.type}}</p>
                                                </div> 	 
                                            </div>   
                                            <div class="thumbnail-description smaller">
                                                <p class="trainingname text" title="{{training.trainingName}}(v{{training.version}})">{{training.trainingName}}(v{{training.version}})</p>
                                                <span style="font-size:12px;">{{training.status}}</span><br>
                                                <span style="font-size:12px;">{{training.lockedByUser}}</span><br>
                                                <span style="font-size:12px;">{{training.createdOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span><br>
                                                <span class="language">{{training.language}}</span>
                                            </div>
                                        </div>
                                    </div> -->
                    <div class="thumbnail mb-2" style="margin-top: 10px">
                      <div class="caption">
                        <div class="container">
                          <img class="img" *ngIf="training.trainingImage == null" style="width: 100%"
                            src="../../assets/img/missing.jpg" />
                          <img class="img" *ngIf="training.trainingImage != null" style="width: 100%" src="data:image/jpg;base64,{{
                                                training.trainingImage
                                              }}" />
                          <div class="text-block-left">
                            <p class="type">{{ training.type }}</p>
                          </div>
                        </div>

                        <div class="thumbnail-description smaller">
                          <div class="d-flex justify-content-between">
                            <div>
                              <p class="trainingname text" title="{{ training.trainingName }}(v{{
                                                    training.version
                                                  }})">
                                {{ training.trainingName }}(v{{
                                training.version
                                }})
                              </p>
                              <div class="d-flex gap-3 mt-3">
                                <span class="card_details">Status :</span>
                                <span class="card_details">{{
                                  training.status
                                  }}</span>
                              </div>
                            </div>

                          </div>
                          <div class="">
                            <div class="card_details author mt-3">
                              <span *ngIf="tab !='Published'" class="authorName"
                                title="{{ training.updatedByUser }}">Author : {{ training.updatedByUser }}</span>
                              <span *ngIf="tab =='Published'" class="authorName"
                                title="{{ training.updatedByUser }}">Author : {{ training.updatedByUser }}</span>
                              <span *ngIf="tab !='Expired'">{{ training.createdOn | date:'dd-MMM-yyyy HH:mm:ss'
                                }}</span>
                              <span *ngIf="tab =='Expired'">{{ training.expiryDate | date:'dd-MMM-yyyy HH:mm:ss'
                                }}</span>

                            </div>
                          </div>

                        </div>
                        <div class="d-flex justify-content-between">
                          <div>
                            <p class="status duration">
                              {{ training.language }}<br>
                              {{ training.totalDuration }}
                            </p>

                          </div>
                          <div class="text-center">
                            <button class="open_cta" mat-stroked-button (click)="updateTrainingFunc(training)">
                              <span *ngIf="tab == 'In Progress'"> Edit</span>
                              <span *ngIf="tab != 'In Progress'"> View</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="caption card-footer text-center"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Published">
                    <ng-template mat-tab-label>
                        <span><i class="fas fa-newspaper" style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;<span>Published</span>
                      </ng-template>
                    <div class="row">
                        <div  class="col-md-12" *ngFor="let category of dropDownForCategories" style="margin-top: 1%;margin-left: 5px;" id="{{category.trainingCategoryName}}">
                            <div class="menu-container" style="margin-left:0px;">
                                <div class="row menu-row-container">
                                    <div class="col-sm-6 gridName-container">
                                        <span class="gridName">{{category.trainingCategoryName}}</span>
                                      </div>
                                </div>
                                <hr>
                              </div>
                            <div class="row">
                                <div class="col-md-15 col-sm-3" *ngFor="let training of getTraining(category.trainingCategoryCode) | searchFilter : searchValue;" (click)="updateTrainingFunc(training)">
                                    <div class="thumbnail">
                                        <div class="caption">
                                            <div class="container">
                                                <img *ngIf="training.trainingImage == null" style="width:100%;" src="../../assets/img/missing.jpg" />
                                                <img *ngIf="training.trainingImage != null" style="width:100%;" src="data:image/jpg;base64,{{training.trainingImage}}" />
                                                <div *ngIf="training.totalDuration" class="text-block-right">
                                                    <p class="duration">{{training.totalDuration}}</p>
                                                </div>
                                                <div class="text-block-left">
                                                    <p class="type">{{training.type}}</p>
                                                </div> 	 
                                            </div>   
                                            <div class="thumbnail-description smaller">
                                                <p class="trainingname text" title="{{training.trainingName}}(v{{training.version}})">{{training.trainingName }}(v{{training.version}})</p>
                                                <span style="font-size:12px;">{{training.status}}</span><br>
                                                <span style="font-size:12px;">{{training.updatedByUser}}</span><br>
                                                <span style="font-size:12px;">{{training.createdOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span><br>
                                                <span class="language">{{training.language}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
          <mat-tab label="Inactivated">
                    <ng-template mat-tab-label>
                        <span><i class='fa fa-ban' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;<span>Inactivated</span>
                      </ng-template>
                    <div class="row">
                        <div  class="col-md-12" *ngFor="let category of dropDownForCategories " style="margin-top: 1%;margin-left: 5px;" id="{{category.trainingCategoryName}}">
                            <div class="menu-container" style="margin-left:0px;">
                                <div class="row menu-row-container">
                                    <div class="col-sm-6 gridName-container">
                                        <span class="gridName">{{category.trainingCategoryName}}</span>
                                      </div>
                                </div>
                                <hr>
                              </div>
                            <div class="row">
                                <div class="col-md-15 col-sm-3" *ngFor="let training of getTraining(category.trainingCategoryCode) | searchFilter : searchValue;" (click)="updateTrainingFunc(training)">
                                    <div class="thumbnail">
                                        <div class="caption">
                                            <div class="container">
                                                <img *ngIf="training.trainingImage == null" style="width:100%;" src="../../assets/img/missing.jpg" />
                                                <img *ngIf="training.trainingImage != null" style="width:100%;" src="data:image/jpg;base64,{{training.trainingImage}}" />
                                                <div *ngIf="training.totalDuration" class="text-block-right">
                                                    <p class="duration">{{training.totalDuration}}</p>
                                                </div>
                                                <div class="text-block-left">
                                                    <p class="type">{{training.type}}</p>
                                                </div> 	 
                                            </div>   
                                            <div class="thumbnail-description smaller">
                                                <p class="trainingname text" title="{{training.trainingName}}(v{{training.version}})">{{training.trainingName}}(v{{training.version}})</p>
                                                <span style="font-size:12px;">{{training.status}}</span><br>
                                                <span style="font-size:12px;">{{training.lockedByUser}}</span><br>
                                                <span style="font-size:12px;">{{training.createdOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span><br>
                                                <span class="language">{{training.language}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab> 
          <!-- <mat-tab label="Obsoleted">
                    <ng-template mat-tab-label>
                        <span><i class='fa fa-times' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;<span>Obsoleted</span>
                      </ng-template>
                    <div class="row">
                        <div  class="col-md-12" *ngFor="let category of dropDownForCategories" style="margin-top: 1%;margin-left: 5px;" id="{{category.trainingCategoryName}}">
                            <div class="menu-container" style="margin-left:0px;">
                                <div class="row menu-row-container">
                                    <div class="col-sm-6 gridName-container">
                                        <span class="gridName">{{category.trainingCategoryName}}</span>
                                      </div>
                                </div>
                                <hr>
                              </div>
                            <div class="row">
                                <div class="col-md-15 col-sm-3" *ngFor="let training of getTraining(category.trainingCategoryCode) | searchFilter : searchValue;" (click)="updateTrainingFunc(training)">
                                    <div class="thumbnail">
                                        <div class="caption">
                                            <div class="container">
                                                <img *ngIf="training.trainingImage == null" style="width:100%;" src="../../assets/img/missing.jpg" />
                                                <img *ngIf="training.trainingImage != null" style="width:100%;" src="data:image/jpg;base64,{{training.trainingImage}}" />
                                                <div *ngIf="training.totalDuration" class="text-block-right">
                                                    <p class="duration">{{training.totalDuration}}</p>
                                                </div>
                                                <div class="text-block-left">
                                                    <p class="type">{{training.type}}</p>
                                                </div> 	 
                                            </div>   
                                            <div class="thumbnail-description smaller">
                                                <p class="trainingname text" title="{{training.trainingName}}(v{{training.version}})">{{training.trainingName}}(v{{training.version}}) </p>
                                                <span style="font-size:12px;">{{training.status}}</span><br>
                                                <span style="font-size:12px;">{{training.lockedByUser}}</span><br>
                                                <span style="font-size:12px;">{{training.createdOn | date:'dd-MMM-yyyy HH:mm:ss'}}</span><br>
                                                <span class="language">{{training.language}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Expired">
                    <ng-template mat-tab-label>
                        <span><i class='fa fa-exclamation-triangle' style="font-size: 18px;" aria-hidden="true"></i></span>&nbsp;<span>Expired</span>
                      </ng-template>
                    <div class="row">
                        <div  class="col-md-12" *ngFor="let category of dropDownForCategories" style="margin-top: 1%;margin-left: 5px;" id="{{category.trainingCategoryName}}">
                            <div class="menu-container" style="margin-left:0px;">
                                <div class="row menu-row-container">
                                    <div class="col-sm-6 gridName-container">
                                        <span class="gridName">{{category.trainingCategoryName}}</span>
                                      </div>
                                </div>
                                <hr>
                              </div>
                            <div class="row">
                                <div class="col-md-15 col-sm-3" *ngFor="let training of getTraining(category.trainingCategoryCode) | searchFilter : searchValue;" (click)="updateTrainingFunc(training)">
                                    <div class="thumbnail">
                                        <div class="caption">
                                            <div class="container">
                                                <img *ngIf="training.trainingImage == null" style="width:100%;" src="../../assets/img/missing.jpg" />
                                                <img *ngIf="training.trainingImage != null" style="width:100%;" src="data:image/jpg;base64,{{training.trainingImage}}" />
                                                <div *ngIf="training.totalDuration" class="text-block-right">
                                                    <p class="duration">{{training.totalDuration}}</p>
                                                </div>
                                                <div class="text-block-left">
                                                    <p class="type">{{training.type}}</p>
                                                </div> 	 
                                            </div>   
                                            <div class="thumbnail-description smaller">
                                                <p class="trainingname text" title="{{training.trainingName}}(v{{training.version}})">{{training.trainingName}}(v{{training.version}}) </p>
                                                <span style="font-size:12px;">{{training.status}}</span><br>
                                                <span style="font-size:12px;">{{training.expiryDate | date:'dd-MMM-yyyy HH:mm:ss'}}</span><br>
                                                <span style="font-size:12px;">{{training.updatedByUser}}</span><br>
                                                <span class="language">{{training.language}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab> -->
        </mat-tab-group>
      </div>
    </div>
  </div>


  <ng-template #confirmWithReasonPopup>
    <h2 mat-dialog-title>{{title}}</h2>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <div style="margin: 15px 15px;">
      <div>
        <div class="row" *ngIf="tmsSettingsObj.esignatureAtTrainingUnlock =='Y'">
          <div><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
          </div>
          <div> <input id="username" style="height: 70% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="userName" disabled>
          </div>
        </div>
        <div class="row" *ngIf="(tmsSettingsObj.esignatureAtTrainingUnlock =='Y' && !isAdenabled)">
          <div><label for="pass ">Password</label><span class="mandatory-symbol">*</span></div>
          <div> <input id="pass" style="height: 70% !important;" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()" noCopyPaste>
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
          <span id="pass-required-msg">Please enter password</span>
        </div>
        <div class="row" *ngIf="isShowDueDate">
          <div><label for="username ">Due Date</label></div>
          <div>
            <input type="text" style="height: 70% !important;" class="form-control data-picker-continer" bsDatepicker
              [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="dueDate">
          </div>
        </div>
        <br>
      </div>
      <div class="button-continer" mat-dialog-actions class="btn-align">
        <button mat-stroked-button class="addButton" (click)="confirmWithFunc()">
          OK
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>
  <app-assign-training #training *ngIf="showAssignTraining"
    (popupClosed)="onTrainingPopupClosed()"></app-assign-training>